import React from 'react'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import useUIContext from 'context/ui'

import s from './ContactButtonCTA.module.scss'
const cn = classNames.bind(s)

const CONTACT_EMAIL = 'make@myriad.video'

const ContactButtonCTA = ({ children, onClick, ...props }) => {
  const isFooterVisible = useUIContext((s) => s.isFooterVisible)
  const isPageTransitioning = useUIContext((s) => s.isPageTransitioning)

  return (
    <a
      href={`mailto:${CONTACT_EMAIL}`}
      className={cn('button', { isPageTransitioning, isFooterVisible })}
      onClick={onClick}
      {...props}
    >
      Contact Us
    </a>
  )
}

ContactButtonCTA.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
}

export default ContactButtonCTA
